jQuery( document ).ready(function($) {
    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $('.menu-wrap').toggleClass('open');
    })
});